import {createRoot, hydrateRoot} from 'react-dom/client';
import SinglePostTemplate from '../pages/SinglePostTemplate/SinglePostTemplate'
import "../index.css";
import "../pages/SinglePostTemplate/SinglePostTemplate.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SinglePostTemplate {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SinglePostTemplate {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SinglePostTemplateVC = {mount, hydrate, unmount}